import { render } from "./TabEventHall.vue?vue&type=template&id=3657f6cc"
import script from "./TabEventHall.vue?vue&type=script&lang=js"
export * from "./TabEventHall.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__